"use strict";

var _defineProperty = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/defineProperty.js");

var _regeneratorRuntime = require("/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _slicedToArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.func = void 0;

var hash_1 = require("../utils/hash");

var stringify_1 = require("../utils/stringify");

var symbols_1 = require("../check/symbols");

var array_1 = require("./array");

var integer_1 = require("./integer");

var tuple_1 = require("./tuple");

var TextEscaper_1 = require("./_internals/helpers/TextEscaper");

function func(arb) {
  return (0, tuple_1.tuple)((0, array_1.array)(arb, {
    minLength: 1
  }), (0, integer_1.integer)().noShrink()).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        outs = _ref2[0],
        seed = _ref2[1];

    var producer = function producer() {
      var _Object$definePropert;

      var recorded = {};

      var f = function f() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var repr = (0, stringify_1.stringify)(args);
        var val = outs[(0, hash_1.hash)("".concat(seed).concat(repr)) % outs.length];
        recorded[repr] = val;
        return (0, symbols_1.hasCloneMethod)(val) ? val[symbols_1.cloneMethod]() : val;
      };

      function prettyPrint(stringifiedOuts) {
        var seenValues = Object.keys(recorded).sort().map(function (k) {
          return "".concat(k, " => ").concat((0, stringify_1.stringify)(recorded[k]));
        }).map(function (line) {
          return "/* ".concat((0, TextEscaper_1.escapeForMultilineComments)(line), " */");
        });
        return "function(...args) {\n  // With hash and stringify coming from fast-check".concat(seenValues.length !== 0 ? "\n  ".concat(seenValues.join('\n  ')) : '', "\n  const outs = ").concat(stringifiedOuts, ";\n  return outs[hash('").concat(seed, "' + stringify(args)) % outs.length];\n}");
      }

      return Object.defineProperties(f, (_Object$definePropert = {
        toString: {
          value: function value() {
            return prettyPrint((0, stringify_1.stringify)(outs));
          }
        }
      }, _defineProperty(_Object$definePropert, stringify_1.toStringMethod, {
        value: function value() {
          return prettyPrint((0, stringify_1.stringify)(outs));
        }
      }), _defineProperty(_Object$definePropert, stringify_1.asyncToStringMethod, {
        value: function () {
          var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.t0 = prettyPrint;
                    _context.next = 3;
                    return (0, stringify_1.asyncStringify)(outs);

                  case 3:
                    _context.t1 = _context.sent;
                    return _context.abrupt("return", (0, _context.t0)(_context.t1));

                  case 5:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function value() {
            return _value.apply(this, arguments);
          }

          return value;
        }()
      }), _defineProperty(_Object$definePropert, symbols_1.cloneMethod, {
        value: producer,
        configurable: true
      }), _Object$definePropert));
    };

    return producer();
  });
}

exports.func = func;